import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const evapotranspirationETc: typeof valueTypeRenderers.evapotranspirationETc = {
  label: () =>
    translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: unitConverter.evapotranspiration().titleWithoutUnit(),
      labelB: translate.phrases.unitSymbols('ETc'),
    }),
  block: () => {
    const { suffix, shortTitle } = unitConverter.evapotranspiration()
    const label = twoItemLabel([`${shortTitle()} ${translate.phrases.unitSymbols('ETc')}`, suffix()])

    return (v) => [
      {
        id: 'value',
        value: unitConverter.evapotranspiration(v).valueAsString(),
        label,
      },
    ]
  },
}
